function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormgroupExpertFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.94 147.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147.94,
    height: 147.94,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "EXPERTEN"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "25.99 101.67 73.97 129.38 121.95 101.67 121.95 46.27 73.97 18.57 25.99 46.27 25.99 101.67",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.09,101.79,74.09,74m0,0L74,18.56M74.12,74l47.54,27.6",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,106c-1.25-5.33-4-13.58-9.28-16.72l-3.15-1.88-.34-3.54a7.55,7.55,0,0,0,.9-.51l0,0,.12-.08a3.25,3.25,0,0,0,1.52-2.15l.42-1.85,1.45-6.47a6.4,6.4,0,0,0,.14-.63l0-.16h0a10.77,10.77,0,0,0,.14-1.56c.07-5.68-3.84-12.64-8.73-15.54-2.24-1.33-4.08-1.64-5.66-1l-.22.07L69.5,54a5.54,5.54,0,0,0-.53.3l-4.13,2.28-.22.45,2,1.52a9.33,9.33,0,0,0-.1,1.33,11,11,0,0,0,0,1.51l0,.13,0,.35c0,.31.08.48.14.79L68.43,73h0a16.37,16.37,0,0,0,2.5,6.16l-.42,2.8c-.77-.46-2.15-1.37-3.15-2-2.07-1.23-3.59-1.31-5-.63l-.19.08-.48.27h0l-3.62,2,.81,1.3a19.26,19.26,0,0,0-1.1,2.5c-.62,1.74.68,4.68,2.58,5.81l14.32,8.49.62.37,11.06,6.56c.15,1.32.38,3.11.5,4a.43.43,0,0,0,.64.32l4-2.24h0C92.26,108.46,92.59,107.4,92.25,106Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3,111.55a.81.81,0,0,1-.37-.09.82.82,0,0,1-.44-.62c-.11-.89-.33-2.56-.48-3.86L60.17,91.65c-2-1.21-3.42-4.37-2.74-6.26a21,21,0,0,1,1-2.35l-.9-1.46L62.23,79c1.58-.77,3.27-.56,5.32.65.54.32,1.19.73,1.79,1.11l.88.55.31-2.08A16.75,16.75,0,0,1,68.05,73L66.37,62.5c0-.19-.07-.35-.1-.58l-.06-.44a11.67,11.67,0,0,1-.07-1.6c0-.37,0-.74.08-1.16l-2.08-1.57.41-.85L68.79,54a4.15,4.15,0,0,1,.56-.3l.09-.06.29-.1c1.66-.7,3.62-.38,6,1,5,3,9,10.08,8.92,15.87a9.22,9.22,0,0,1-.11,1.36h0l-.09.44a4.56,4.56,0,0,1-.14.64l-1.87,8.31a3.59,3.59,0,0,1-1.68,2.38l-.1.08c-.27.17-.52.32-.76.44l.3,3.09,3,1.78c5.25,3.12,8,10.94,9.45,17,.36,1.54,0,2.82-.9,3.33l-4,2.24A.79.79,0,0,1,87.3,111.55ZM58.62,81.85,59.33,83l-.1.19a18.29,18.29,0,0,0-1.08,2.45c-.57,1.57.67,4.32,2.41,5.35l26.17,15.52,0,.19c.15,1.32.38,3.1.5,4l4.1-2.21c.6-.33.81-1.31.53-2.48h0c-1.13-4.81-3.81-13.35-9.1-16.49l-3.32-2-.39-4,.24-.12a8.49,8.49,0,0,0,.86-.49l.13-.09A2.81,2.81,0,0,0,81.67,81l1.88-8.33a6,6,0,0,0,.14-.61l0-.16a10.09,10.09,0,0,0,.14-1.5c.06-5.56-3.77-12.38-8.55-15.21-2.11-1.26-3.85-1.57-5.31-1l-.3.12a4.86,4.86,0,0,0-.51.28l-4.08,2.3L67,58.38l0,.22a8.66,8.66,0,0,0-.1,1.29,10,10,0,0,0,0,1.46l0,.08,0,.39c0,.21,0,.35.09.53l0,.24,1.64,10.33a15.8,15.8,0,0,0,2.44,6l.08.13-.52,3.5-.49-.29c-.36-.21-.86-.52-1.38-.86s-1.24-.78-1.78-1.09c-1.83-1.09-3.26-1.28-4.62-.62l-.2.09Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE",
    d: "M87.82,108.44c-1.26-5.33-4-13.58-9.29-16.73l-3.15-1.87L75,86.3a4.21,4.21,0,0,0,2.57-2.76L78,81.69l1.45-6.48a5.62,5.62,0,0,0,.15-.62l0-.17h0a9.52,9.52,0,0,0,.14-1.56c.07-5.69-3.84-12.64-8.73-15.54s-8.91-.64-9,5a11,11,0,0,0,0,1.51l0,.13,0,.35c0,.3.09.48.14.79L64,75.46h0a16.37,16.37,0,0,0,2.5,6.16l-.41,2.79c-.77-.45-2.16-1.36-3.16-2-5.32-3.16-8.2,1.76-9.57,5.54-.62,1.73.68,4.68,2.58,5.8l14.32,8.5.62.36,14.27,8.47C87,112.25,88.39,110.88,87.82,108.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.41,111.9a2.87,2.87,0,0,1-1.46-.45L55.73,94.13c-2-1.21-3.42-4.37-2.73-6.26.88-2.46,2.49-5.59,5.09-6.52a5.81,5.81,0,0,1,5,.78l1.77,1.1.89.56.31-2.08a16.9,16.9,0,0,1-2.47-6.19L61.93,65c0-.19-.07-.35-.09-.58L61.77,64a11.59,11.59,0,0,1-.06-1.61c0-2.89,1-5,2.87-6.06s4.19-.78,6.68.7c5,3,9,10.08,8.91,15.87a10.61,10.61,0,0,1-.1,1.35h0l-.09.45c0,.21-.09.43-.15.64L78,83.62a4.32,4.32,0,0,1-2.54,2.9l.3,3.09,3,1.78c5.25,3.11,8,10.94,9.46,17h0c.33,1.44.06,2.64-.72,3.22A1.8,1.8,0,0,1,86.41,111.9ZM59.7,81.83a4.07,4.07,0,0,0-1.35.23c-2.33.84-3.81,3.76-4.64,6.07-.56,1.57.68,4.32,2.41,5.35L85.34,110.8A1.53,1.53,0,0,0,87,111a2.37,2.37,0,0,0,.42-2.44c-1.13-4.8-3.81-13.34-9.1-16.48l-3.32-2-.38-4,.23-.12a3.81,3.81,0,0,0,2.37-2.5l1.87-8.33c.06-.21.1-.4.14-.61l0-.16a10.27,10.27,0,0,0,.13-1.51c.07-5.55-3.77-12.37-8.54-15.2-2.24-1.33-4.34-1.58-5.92-.7s-2.45,2.81-2.48,5.41a10.07,10.07,0,0,0,.05,1.47l0,.08.05.39c0,.21.06.35.09.52l0,.25L64.37,75.4a15.8,15.8,0,0,0,2.44,6l.08.13L66.37,85l-.49-.29-1.39-.87-1.76-1.09A6.05,6.05,0,0,0,59.7,81.83Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.27 71.13 83.94 67.28 79.49 69.78 80 72.44 78.01 82.06 77.89 82.13 77.38 84.21 75.73 86.03 75.04 86.3 75.38 89.84 79.82 87.36 79.48 83.82 81.48 82.68 82.16 80.36 82.39 79.55 84.27 71.13",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.77 104.56 91.04 102.02 92.19 105.19 92.35 107.18 92 108.7 87.51 111.11 87.95 109.25 87.07 105.32 86.77 104.56",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.32,67.73c0-5.51-4.13-12.29-9-14.48-1.81-.82-3.3-.9-4.56-.21l-.15.08h0l0,0-4,2.33a.35.35,0,0,0-.11.51l1.67,2.26c-.06,3.94,2,8.56,5,11.7v3.31c0,.62.63,1.31,1,1.13l2.67-1.21,1,1.73a.39.39,0,0,0,.53.14L104.91,73h0C106.4,72.14,107.32,70.33,107.32,67.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.17,75.48a.64.64,0,0,1-.2,0,.79.79,0,0,1-.47-.37l-.8-1.41-2.34,1.06a.86.86,0,0,1-.81-.1,1.77,1.77,0,0,1-.76-1.38V70.09a18.22,18.22,0,0,1-5-11.73l-1.58-2.15a.69.69,0,0,1-.13-.59.72.72,0,0,1,.35-.48l4.17-2.44c1.35-.74,3-.67,4.89.2,4.92,2.21,9.24,9.14,9.24,14.83,0,2.55-.85,4.47-2.41,5.46h0l-.19.12-3.54,2.06A.79.79,0,0,1,101.17,75.48ZM100,72.68l1.13,2,3.57-2.07c1.42-.8,2.21-2.55,2.21-4.91,0-5.43-4.11-12-8.79-14.14-1.71-.76-3.09-.84-4.23-.22l-.16.09-4,2.33,1.75,2.32v.13c-.06,3.7,1.92,8.29,4.91,11.44l.11.11v3.46a.93.93,0,0,0,.51.78Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42,70c0-5.51-4.14-12.29-9-14.49-3.63-1.63-6.62,0-7.09,3.92-.51,4.15,1.69,9.35,5,12.78v3.31c0,.62.63,1.31,1,1.13l3.16-1.43C100.39,76.85,103.42,74.71,103.42,70Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.16,77.06a.93.93,0,0,1-.51-.16,1.77,1.77,0,0,1-.76-1.38V72.36c-3.41-3.64-5.45-9-5-13a5.47,5.47,0,0,1,2.52-4.31,5.62,5.62,0,0,1,5.11.09c4.92,2.21,9.24,9.14,9.24,14.83,0,2.49-.83,4.41-2.33,5.41a5.33,5.33,0,0,1-5,.22l-3,1.37A.8.8,0,0,1,93.16,77.06ZM91.73,55.27a3.88,3.88,0,0,0-1.9.47,4.73,4.73,0,0,0-2.14,3.74c-.47,3.85,1.53,9,4.85,12.46l.11.12v3.46a.91.91,0,0,0,.51.78l3.29-1.49.15.06a4.68,4.68,0,0,0,4.45-.09c1.28-.86,2-2.55,2-4.78,0-5.43-4.1-12-8.78-14.14A6.27,6.27,0,0,0,91.73,55.27Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.71 65.78 106.64 63.5 107.32 65.53 107.32 68.96 106.94 70.78 104.06 73.61 101.74 74.71 103.42 71.33 103.42 67.73 102.71 65.78",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-2",
    "data-name": "ACTIVE",
    d: "M92.59,64.31c0,.9-.63,1.26-1.41.81a3.12,3.12,0,0,1-1.4-2.43c0-.9.63-1.26,1.4-.81A3.08,3.08,0,0,1,92.59,64.31Zm2.5-.15c-.78-.45-1.41-.08-1.41.81a3.11,3.11,0,0,0,1.41,2.44c.77.44,1.4.08,1.4-.82A3.12,3.12,0,0,0,95.09,64.16ZM99,66.38c-.78-.45-1.4-.09-1.4.81A3.1,3.1,0,0,0,99,69.62c.78.45,1.41.08,1.41-.81A3.08,3.08,0,0,0,99,66.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.81,65.56a1.54,1.54,0,0,1-.75-.23,3.32,3.32,0,0,1-1.53-2.65,1.1,1.1,0,0,1,1.78-1,3.34,3.34,0,0,1,1.53,2.65,1.22,1.22,0,0,1-.54,1.13A.9.9,0,0,1,91.81,65.56Zm-1.25-3.63a.48.48,0,0,0-.24.06.78.78,0,0,0-.29.69,2.88,2.88,0,0,0,1.28,2.21.74.74,0,0,0,.74.1.76.76,0,0,0,.29-.69,2.88,2.88,0,0,0-1.28-2.21A1.08,1.08,0,0,0,90.56,61.93Zm9.06,8.14a1.55,1.55,0,0,1-.76-.23,3.37,3.37,0,0,1-1.53-2.65,1.11,1.11,0,0,1,1.79-1,3.32,3.32,0,0,1,1.53,2.65,1.22,1.22,0,0,1-.54,1.13A1,1,0,0,1,99.62,70.07Zm-1.26-3.63a.48.48,0,0,0-.24.06.75.75,0,0,0-.28.69,2.85,2.85,0,0,0,1.28,2.21.61.61,0,0,0,1-.59,2.85,2.85,0,0,0-1.28-2.21A1,1,0,0,0,98.36,66.44Zm-2.64,1.37a1.53,1.53,0,0,1-.76-.22,3.34,3.34,0,0,1-1.53-2.66,1.11,1.11,0,0,1,1.79-1,3.37,3.37,0,0,1,1.53,2.66,1.26,1.26,0,0,1-.54,1.13A1,1,0,0,1,95.72,67.81Zm-1.26-3.62a.47.47,0,0,0-.24,0,.78.78,0,0,0-.28.69,2.87,2.87,0,0,0,1.28,2.22.61.61,0,0,0,1-.59A2.89,2.89,0,0,0,95,64.34,1.05,1.05,0,0,0,94.46,64.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.87,114a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,81.87,114Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.48,112.47a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0c-.28-.16-.28-.41,0-.57A1.1,1.1,0,0,1,84.48,112.47Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.26,112.47c.28.16.28.41,0,.57a1.08,1.08,0,0,1-1,0c-.28-.16-.28-.41,0-.57A1.08,1.08,0,0,1,79.26,112.47Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.87,111a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,81.87,111Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.66,111a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,76.66,111Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.77,
    cy: 109.75,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.55,
    cy: 109.75,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.66,108a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,76.66,108Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.95,
    cy: 108.24,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,106.45c.28.16.28.42,0,.57a1.08,1.08,0,0,1-1,0c-.28-.15-.28-.41,0-.57A1.08,1.08,0,0,1,74.05,106.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.82,106.43a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,68.82,106.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.42,104.93c.28.16.28.42,0,.57a1.08,1.08,0,0,1-1,0c-.28-.15-.28-.41,0-.57A1.08,1.08,0,0,1,71.42,104.93Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.21,104.93c.28.16.28.42,0,.57a1.1,1.1,0,0,1-1,0c-.27-.15-.27-.41,0-.57A1.1,1.1,0,0,1,66.21,104.93Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.82,103.42a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,68.82,103.42Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.11,
    cy: 103.71,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.21,101.92c.28.16.28.42,0,.57a1.1,1.1,0,0,1-1,0c-.27-.15-.27-.41,0-.57A1.1,1.1,0,0,1,66.21,101.92Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,101.92c.27.16.27.42,0,.57a1.1,1.1,0,0,1-1,0c-.27-.15-.27-.41,0-.57A1.1,1.1,0,0,1,61,101.92Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6,100.41a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.15,1.15,0,0,1,63.6,100.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.39,100.41a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.15,1.15,0,0,1,58.39,100.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5,
    cy: 99.2,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.79,98.91a.31.31,0,0,1,0,.58,1.17,1.17,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,55.79,98.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.39,97.41c.28.15.28.41,0,.57a1.08,1.08,0,0,1-1,0c-.28-.16-.28-.42,0-.57A1.08,1.08,0,0,1,58.39,97.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.18,97.41c.27.15.27.41,0,.57a1.1,1.1,0,0,1-1,0c-.27-.16-.27-.42,0-.57A1.1,1.1,0,0,1,53.18,97.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.79,95.9a.31.31,0,0,1,0,.58,1.17,1.17,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,55.79,95.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.18,94.4c.27.15.27.41,0,.57a1.1,1.1,0,0,1-1,0c-.27-.16-.27-.42,0-.57A1.1,1.1,0,0,1,53.18,94.4Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,115.24c.28.16.28.41,0,.57a1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,89.79,115.24Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,113.73a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,92.4,113.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,112.23c.28.16.28.41,0,.57a1.08,1.08,0,0,1-1,0c-.28-.16-.28-.41,0-.57A1.08,1.08,0,0,1,95,112.23Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.58,115.24a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,84.58,115.24Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.19,113.73a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,87.19,113.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,112.23c.28.16.28.41,0,.57a1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,89.79,112.23Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,110.72a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,92.4,110.72Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,109.22c.28.16.28.41,0,.57a1.08,1.08,0,0,1-1,0c-.28-.16-.28-.41,0-.57A1.08,1.08,0,0,1,95,109.22Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,18.56,26,46.27,74,74l48-27.7Zm48,27.71L74,74v55.41l48-27.71ZM74,74,26,46.27v55.4l48,27.71Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormgroupExpertFrame);
export default __webpack_public_path__ + "static/media/formgroup_ExpertFrame.5c3fd8efa4135fd3fc40de7e8d5ee1f6.svg";
export { ForwardRef as ReactComponent };